export default {
  'app.setting.pagestyle': 'Configuração do estilo da página',
  'app.setting.pagestyle.dark': 'Modo escuro',
  'app.setting.pagestyle.light': 'Modo claro',
  'app.setting.content-width': 'Largura do conteúdo',
  'app.setting.content-width.fixed': 'Fixa',
  'app.setting.content-width.fluid': 'Fluida',
  'app.setting.themecolor': 'Cor do tema',
  'app.setting.themecolor.dust': 'Vermelho Poeira',
  'app.setting.themecolor.volcano': 'Vulcão',
  'app.setting.themecolor.sunset': 'Laranja Pôr do Sol',
  'app.setting.themecolor.cyan': 'Ciano',
  'app.setting.themecolor.green': 'Verde Polar',
  'app.setting.themecolor.daybreak': 'Azul Amanhecer (padrão)',
  'app.setting.themecolor.geekblue': 'Azul Geek',
  'app.setting.themecolor.purple': 'Roxo Dourado',
  'app.setting.navigationmode': 'Modo de navegação',
  'app.setting.sidemenu': 'Layout de menu lateral',
  'app.setting.topmenu': 'Layout de menu superior',
  'app.setting.fixedheader': 'Cabeçalho fixo',
  'app.setting.fixedsidebar': 'Barra lateral fixa',
  'app.setting.fixedsidebar.hint': 'Funciona no layout com menu lateral',
  'app.setting.hideheader': 'Ocultar cabeçalho ao rolar',
  'app.setting.hideheader.hint':
    'Funciona quando o cabeçalho oculto está ativado',
  'app.setting.othersettings': 'Outras configurações',
  'app.setting.weakmode': 'Modo amigável para daltônicos',
  'app.setting.copy': 'Copiar configuração',
  'app.setting.copyinfo':
    'Cópia realizada com sucesso, substitua defaultSettings em src/models/setting.js',
  'app.setting.production.hint':
    'O painel de configurações é exibido apenas no ambiente de desenvolvimento, modifique manualmente',
};
